<script lang="ts">
import { ActionEnum } from "@/store/enum/authActionEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { PartnerModule } from "@/store/modules/partner";
import { UserModule } from "@/store/modules/me-user.store";
import { Component, Vue } from "vue-property-decorator";
import { PartnerTypeEnum } from "@/store/enum/partner/partner.type.enum";

@Component({})
export default class PermissionMixin extends Vue {
  get isAdmin() {
    return UserModule.isAdmin;
  }

  get ActionEnum() {
    return ActionEnum;
  }
  get ResourceEnum() {
    return ResourceEnum;
  }

  get permissionPartnerId() {
    return PartnerModule.partner && PartnerModule.partner.id ? PartnerModule.partner.id : "";
  }

  get canCreateUser() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.USER, this.permissionPartnerId);
  }

  get canUpdateUser() {
    return UserModule.abilities.can(ActionEnum.UPDATE, ResourceEnum.USER, this.permissionPartnerId);
  }

  get canCreateAI() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.AI, this.permissionPartnerId);
  }

  get canReadForm() {
    return UserModule.abilities.can(ActionEnum.READ, ResourceEnum.FORM, this.permissionPartnerId);
  }

  get canReadReport() {
    return UserModule.abilities.can(ActionEnum.READ, ResourceEnum.REPORT, this.permissionPartnerId);
  }

  get canReadMessage() {
    return UserModule.abilities.can(ActionEnum.READ, ResourceEnum.MESSAGE, this.permissionPartnerId);
  }

  get canCreateMessage() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.MESSAGE, this.permissionPartnerId);
  }

  get canCreateImage() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.IMAGE, this.permissionPartnerId);
  }

  get canManageBooking() {
    return UserModule.abilities.can(ActionEnum.MANAGE, ResourceEnum.BOOKING, this.permissionPartnerId);
  }

  get readMessage() {
    return UserModule.abilities.can(ActionEnum.READ, ResourceEnum.MESSAGE, this.permissionPartnerId);
  }

  get canReadFleet() {
    return UserModule.abilities.can(ActionEnum.READ, ResourceEnum.FLEET, this.permissionPartnerId);
  }

  get canCreateFleet() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.FLEET, this.permissionPartnerId);
  }

  get canUpdateFleet() {
    return UserModule.abilities.can(ActionEnum.UPDATE, ResourceEnum.FLEET, this.permissionPartnerId);
  }

  get canDeleteFleet() {
    return UserModule.abilities.can(ActionEnum.DELETE, ResourceEnum.FLEET, this.permissionPartnerId);
  }

  get canCreateReport() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.REPORT, this.permissionPartnerId);
  }

  get canUpdateReport() {
    return UserModule.abilities.can(ActionEnum.UPDATE, ResourceEnum.REPORT, this.permissionPartnerId);
  }

  get canReadReportGroup() {
    return UserModule.abilities.can(ActionEnum.READ, ResourceEnum.REPORT_GROUP, this.permissionPartnerId);
  }

  get canCreateReportGroup() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.REPORT_GROUP, this.permissionPartnerId);
  }

  get canUpdateReportGroup() {
    return UserModule.abilities.can(ActionEnum.UPDATE, ResourceEnum.REPORT_GROUP, this.permissionPartnerId);
  }

  get canDeleteReportGroup() {
    return UserModule.abilities.can(ActionEnum.DELETE, ResourceEnum.REPORT_GROUP, this.permissionPartnerId);
  }

  get canCreateSign() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.SIGN, this.permissionPartnerId);
  }

  get canCreateDocument() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.DOCUMENT, this.permissionPartnerId);
  }

  get canReadDocument() {
    return UserModule.abilities.can(ActionEnum.READ, ResourceEnum.DOCUMENT, this.permissionPartnerId);
  }

  get canUpdateDocument() {
    return UserModule.abilities.can(ActionEnum.UPDATE, ResourceEnum.DOCUMENT, this.permissionPartnerId);
  }

  get canDeleteDocument() {
    return UserModule.abilities.can(ActionEnum.DELETE, ResourceEnum.DOCUMENT, this.permissionPartnerId);
  }

  get canShareContent() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.SHARED_CONTENT, this.permissionPartnerId);
  }

  get canCreateAttachmentRequest() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.ATTACHMENT_REQUEST, this.permissionPartnerId);
  }

  get canReadTemplate() {
    return UserModule.abilities.can(ActionEnum.READ, ResourceEnum.TEMPLATE, this.permissionPartnerId);
  }

  get canEditTemplate() {
    return UserModule.abilities.can(ActionEnum.UPDATE, ResourceEnum.TEMPLATE, this.permissionPartnerId);
  }

  get canReadActivity() {
    return UserModule.abilities.can(ActionEnum.READ, ResourceEnum.ACTIVITY, this.permissionPartnerId);
  }

  get canCreateActivity() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.ACTIVITY, this.permissionPartnerId);
  }

  get canUpdateActivity() {
    return UserModule.abilities.can(ActionEnum.UPDATE, ResourceEnum.ACTIVITY, this.permissionPartnerId);
  }

  get deleteUpdateActivity() {
    return UserModule.abilities.can(ActionEnum.DELETE, ResourceEnum.ACTIVITY, this.permissionPartnerId);
  }

  get canReadVehicle() {
    return UserModule.abilities.can(ActionEnum.READ, ResourceEnum.VEHICLE, this.permissionPartnerId);
  }

  get canCreateVehicle() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.VEHICLE, this.permissionPartnerId);
  }

  get canReadContract() {
    return UserModule.abilities.can(ActionEnum.READ, ResourceEnum.CONTRACT, this.permissionPartnerId);
  }

  get canCreateContract() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.CONTRACT, this.permissionPartnerId);
  }

  get canReadEvent() {
    return UserModule.abilities.can(ActionEnum.READ, ResourceEnum.EVENT, this.permissionPartnerId);
  }

  get canCreateEvent() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.EVENT, this.permissionPartnerId);
  }

  get canReadAnalytics() {
    return UserModule.abilities.can(ActionEnum.READ, ResourceEnum.ANALYTICS, this.permissionPartnerId);
  }

  get canReadTicket() {
    return UserModule.abilities.can(ActionEnum.READ, ResourceEnum.TICKET, this.permissionPartnerId);
  }

  get canCreateTicket() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.TICKET, this.permissionPartnerId);
  }

  get canCreateCost() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.COST, this.permissionPartnerId);
  }

  get canCreateCompany() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.COMPANY, this.permissionPartnerId);
  }

  get canReadCompany() {
    return UserModule.abilities.can(ActionEnum.READ, ResourceEnum.COMPANY, this.permissionPartnerId);
  }

  get canUpdateCompany() {
    return UserModule.abilities.can(ActionEnum.UPDATE, ResourceEnum.COMPANY, this.permissionPartnerId);
  }

  get canCreateCompanyGroup() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.COMPANY_GROUP, this.permissionPartnerId);
  }

  get canCreatePerson() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.PERSON, this.permissionPartnerId);
  }

  get canReadPerson() {
    return UserModule.abilities.can(ActionEnum.READ, ResourceEnum.PERSON, this.permissionPartnerId);
  }

  get canUpdatePerson() {
    return UserModule.abilities.can(ActionEnum.UPDATE, ResourceEnum.PERSON, this.permissionPartnerId);
  }

  get canCreatePersonGroup() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.PERSON_GROUP, this.permissionPartnerId);
  }

  get canCreateLead() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.LEAD, this.permissionPartnerId);
  }

  get canCreateLeadGroup() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.LEAD_GROUP, this.permissionPartnerId);
  }

  get canCreateGroup() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.GROUP, this.permissionPartnerId);
  }

  get canCreateBlueprint() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.BLUEPRINT, this.permissionPartnerId);
  }

  get canCreateProduct() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.PRODUCT, this.permissionPartnerId);
  }

  get canReadProduct() {
    return UserModule.abilities.can(ActionEnum.READ, ResourceEnum.PRODUCT, this.permissionPartnerId);
  }

  get canReadRepairEstimate() {
    return UserModule.abilities.can(ActionEnum.READ, ResourceEnum.REPAIR_ESTIMATE, this.permissionPartnerId);
  }

  get canCreateRepairEstimate() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.REPAIR_ESTIMATE, this.permissionPartnerId);
  }

  get canUpdateRepairEstimate() {
    return UserModule.abilities.can(ActionEnum.UPDATE, ResourceEnum.REPAIR_ESTIMATE, this.permissionPartnerId);
  }

  get canDeleteRepairEstimate() {
    return UserModule.abilities.can(ActionEnum.DELETE, ResourceEnum.REPAIR_ESTIMATE, this.permissionPartnerId);
  }

  get canReadAppraisal() {
    return UserModule.abilities.can(ActionEnum.READ, ResourceEnum.APPRAISAL, this.permissionPartnerId);
  }

  get canCreateAppraisal() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.APPRAISAL, this.permissionPartnerId);
  }

  get canUpdateAppraisal() {
    return UserModule.abilities.can(ActionEnum.UPDATE, ResourceEnum.APPRAISAL, this.permissionPartnerId);
  }

  get canDeleteAppraisal() {
    return UserModule.abilities.can(ActionEnum.DELETE, ResourceEnum.APPRAISAL, this.permissionPartnerId);
  }

  get canReadClearance() {
    return UserModule.abilities.can(ActionEnum.READ, ResourceEnum.CLEARANCE, this.permissionPartnerId);
  }

  get canCreateClearance() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.CLEARANCE, this.permissionPartnerId);
  }
  get canUpdateClearance() {
    return UserModule.abilities.can(ActionEnum.UPDATE, ResourceEnum.CLEARANCE, this.permissionPartnerId);
  }

  get canReadRental() {
    return UserModule.abilities.can(ActionEnum.READ, ResourceEnum.RENTAL, this.permissionPartnerId);
  }

  get canCreateRental() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.RENTAL, this.permissionPartnerId);
  }
  get canUpdateRental() {
    return UserModule.abilities.can(ActionEnum.UPDATE, ResourceEnum.RENTAL, this.permissionPartnerId);
  }
  get canDeleteRental() {
    return UserModule.abilities.can(ActionEnum.DELETE, ResourceEnum.RENTAL, this.permissionPartnerId);
  }

  get canReadCall() {
    return UserModule.abilities.can(ActionEnum.READ, ResourceEnum.CALL, this.permissionPartnerId);
  }

  can(i: ActionEnum, a: string | ResourceEnum) {
    return UserModule.abilities.can(i, a, this.permissionPartnerId);
  }

  canRead(a: string | ResourceEnum) {
    return UserModule.abilities.can(ActionEnum.READ, a, this.permissionPartnerId);
  }

  get isFleetPartner() {
    return [PartnerTypeEnum.FLEET, PartnerTypeEnum.TRAIN].includes(
      PartnerModule.partner.partnerType as PartnerTypeEnum
    );
  }

  get isTrainPartner() {
    return (PartnerModule.partner.partnerType as PartnerTypeEnum) === PartnerTypeEnum.TRAIN;
  }

  get isWorkshopPartner() {
    return PartnerModule.partner.partnerType === PartnerTypeEnum.WORKSHOP;
  }
}
</script>
